import { render, staticRenderFns } from "./salon_edit.vue?vue&type=template&id=424cf569&scoped=true"
import script from "./salon_edit.vue?vue&type=script&lang=js"
export * from "./salon_edit.vue?vue&type=script&lang=js"
import style0 from "./salon_edit.vue?vue&type=style&index=0&id=424cf569&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424cf569",
  null
  
)

export default component.exports